import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {EMPTY, Observable, of} from 'rxjs';
import {ConfigurationObject, SearchObjectsExObj} from '../interfaces/interfaces.regisafe';
import {StorageService} from '../provider/storage/storage.service';
import {SettingsService} from '../provider/settings/settings.service';
import {IQApiService} from '../provider/iqapi/iqapi.service';
import {catchError, mergeMap} from 'rxjs/Operators';
import {MessagesService} from '../provider/messages/messages.service';
import {AppConfig} from '../app.config';
import {SessionDataService} from '../provider/session-data/session-data.service';
import {LoadingController} from '@ionic/angular';
import {UserService} from '../provider/user/user.service';

@Injectable({
	providedIn: 'root'
})
export class SuchergebnisseResolver implements Resolve<Observable<any>> {

	public configuration: ConfigurationObject;
	loader: HTMLIonLoadingElement;

	constructor(private storageService: StorageService,
				private settingsService: SettingsService,
				private loadingCtrl: LoadingController,
				private userService: UserService,
				private sessionData: SessionDataService,
				private iqAPI: IQApiService,
				private router: Router,
				private msgService: MessagesService,
				public appConfig: AppConfig) {

		this.configuration = this.appConfig.getConfig();

	}

	// eslint-disable-next-line max-len
	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Observable<any>> | Promise<Observable<any>> | Observable<any> {

		this.userService.presentLoader();

		// Query Paramter auslesen und and BODY Object übergeben
		const tempBody: SearchObjectsExObj = {};
		tempBody.osId = route.queryParamMap.get('osId');

		if (route.queryParamMap.get('searchText')) {
			tempBody.searchText = route.queryParamMap.get('searchText');
		}
		if (route.queryParamMap.get('savedSearchCriteria')) {
			tempBody.savedSearchCriteria = route.queryParamMap.get('savedSearchCriteria');
		}
		if (route.queryParamMap.get('searchFields')) {
			tempBody.searchFields = JSON.parse(atob(route.queryParamMap.get('searchFields')));
		}
		if (route.queryParamMap.get('sortFields')) {
			tempBody.sortFields = route.queryParamMap.get('sortFields');
		}

		tempBody.apiID = this.configuration.iqapiAppId;
		tempBody.sessionToken = this.storageService.getToken();

		const fields = this.storageService.getOSFieldsFromCondtionsSync(tempBody.osId);
		tempBody.fields = fields.join(',');

		if (this.sessionData.dataStores.length > 0) {
			tempBody.dataStores = this.sessionData.dataStores;
		}

		const body = Object.assign(tempBody, this.settingsService.defaultBodySettings);
		const navigationTarget = route.queryParamMap.get('navigationTarget');

		body.getHits = this.settingsService.getUserSettings().getHits;

		// Suchmodus an searchFields übergeben. Diese werden bei der Anmeldung
		// aus app.searchwordmode.json gelsen und in der Datenbank (localStorage) gespeichert
		// ---------
		// \SP Phonetische Suche (ohne diese Angabe: Exakte Suche)
		// \SG Genaue wortweise Suche (Standard-Vorgabe, wenn \SA oder \SI fehlt)
		// \SA Wortanfang-Suche ("Kinder" findet auch "Kindergarten")
		// \SI Innerhalb-Suche ("Inder" findet auch "Kindergarten"; langsame Suche)
		// ---------
		const searchWordModeData = this.storageService.getSearchModeData();
		if (body.searchFields) {
			Object.keys(body.searchFields).forEach((item) => {
				if (searchWordModeData[body.osId].hasOwnProperty(item)) {
					if (body.searchFields[item] !== '') {
						body.searchFields[item] = body.searchFields[item] + searchWordModeData[body.osId][item];
					}
				}
			});
		}

		console.log('### body ###: ', body);

		// if (this.sessionData.searchResultCache.stateURL === state.url &&
		// 	Object.keys(this.sessionData.searchResultCache.data).length !== 0) {
		//
		// 	setTimeout(() => {
		// 		this.userService.dismissLoader();
		// 	}, 500);
		//
		// 	const resultObj = {
		// 		/* eslint-disable object-shorthand */
		// 		data: this.sessionData.searchResultCache.data,
		// 		body: body,
		// 		cache: true
		// 	};
		//
		// 	return of(resultObj);
		// }
		//
		// this.sessionData.jsonBody = body;

		// Anfrage an IQAPI (OrgaManagerSearchObjectsEx)
		return this.iqAPI.orgaManagerSearchObjectsEx(body)
			.pipe(
				catchError((e) => {
					let errorMsg: string;
					if (e.error.hasOwnProperty('_error')) {
						// eslint-disable-next-line no-underscore-dangle
						errorMsg = e.error._error['1'].hl + ': ' + e.error._error['1'].eMsg;
					} else {
						errorMsg = e.message;
					}
					this.msgService.sendMessage({context: 'searchresolver:catcherror', text: errorMsg, error: e});
					this.userService.dismissLoader();
					return EMPTY;
				}),
				mergeMap((data) => {

					// this.sessionData.searchResultCache.data = data;
					// this.sessionData.searchResultCache.stateURL = state.url;
					this.userService.dismissLoader();
					if (data.totalCount === 0) {
						this.router.navigate([navigationTarget]).then((e) => {
							this.msgService.sendMessage({
								context: 'searchresolver:noresults', text: 'Es wurden keine Ergebnisse gefunden.'
							});
						});
						return EMPTY;
					} else {

						const resultObj = {
							/* eslint-disable object-shorthand */
							data: data,
							body: body
						};
						return of(resultObj);
					}
				})
			);
	}
}
